export default "__VITE_ASSET__DWq3f$hl__"